import './App.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./Layout";
import Home from './pages/Home';
import Projects from './pages/Projects';
import Parcours from './pages/Parcours';
import Aniflex from './pages/Projects/Aniflex';
import InternshipFinder from './pages/Projects/InternshipFinder';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/projects", element: <Projects /> },
      { path: "/parcours", element: <Parcours /> },
      { path: "/Projects/Aniflex", element: <Aniflex/>},
      { path: "/Projects/InternshipFinder", element: <InternshipFinder/>}
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
